import { useMemo } from 'react'

import { PermissionsContext } from '@permissions/permissions.context'
import { usePermissions } from '@permissions/permissions.hooks'
import { ActionScopes, ResourcesScopes, isAllowed } from '@permissions/permissions.logic'
import {
  PermissionsProviderProps,
  PermissionsContextType,
  PermissionsResources,
  PermissionsActions,
} from '@permissions/permissions.types'

const PermissionsProvider = ({ permissions, children }: PermissionsProviderProps) => {
  const { isLoading } = usePermissions()

  const isAllowedTo = (resource: PermissionsResources, action: PermissionsActions) => {
    return permissions ? isAllowed(`${ResourcesScopes[resource]}:${ActionScopes[action]}`, permissions) : false
  }

  const value: PermissionsContextType = useMemo(() => {
    return { isLoading, isAllowedTo }
  }, [isLoading, isAllowedTo])

  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>
}

export default PermissionsProvider
